import axios from "axios";
import AppSettings from "../appsettings";

const API_BASE = `${AppSettings.API_BASE_URL}/dashboardanalytics`;

const DashboardApiService = {
  // ✅ Admin: Get merged analytics for all publishers
  getMergedDashboard: async () => {
    try {
      const response = await axios.get(`${API_BASE}/merged-dashboard`);
      return response.data;
    } catch (error) {
      console.error("❌ Failed to fetch merged dashboard (admin):", error);
      throw error;
    }
  },

  // ✅ Publisher: Get merged analytics for a specific publisher
  getMergedPublisherDashboard: async (publisherId) => {
    try {
      const response = await axios.get(`${API_BASE}/merged-dashboard/${publisherId}`);
      return response.data;
    } catch (error) {
      console.error("❌ Failed to fetch merged dashboard (publisher):", error);
      throw error;
    }
  },
};

export default DashboardApiService;
